import Vue from 'vue';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import store from '../store';

dayjs.extend(utc);
dayjs.extend(timezone);

Vue.filter('dateTimeFormatFromSettings', str => {
    if (!str) {
        return '';
    }

    const settings = store.getters['settings/getSettings'];

    if (!settings) {
        return;
    }

    const { timeZone, dateFormat } = settings;

    return dayjs(str)
        .tz(timeZone)
        .format(`${dateFormat} HH:mm`);
});
